import { __rest } from 'tslib';
import React from 'react';
import Icon from '@ant-design/icons';
import { I as IconBase } from '../IconBase-df74767e.js';

const IconComponent = (props, ref) => {
    const data = {
        tag: 'svg',
        attr: { viewBox: '0 0 24 24', fill: 'none' },
        child: [
            {
                tag: 'path',
                attr: {
                    fillRule: 'evenodd',
                    clipRule: 'evenodd',
                    d: 'M23.5 12.9998C23.5 13.552 23.0523 13.9998 22.5 13.9998H14C12.3431 13.9998 11 12.6566 11 10.9998V1.5C11 0.947715 11.4477 0.5 12 0.5C12.5523 0.5 13 0.947715 13 1.5V10.9998C13 11.552 13.4477 11.9998 14 11.9998H22.5C23.0523 11.9998 23.5 12.4475 23.5 12.9998Z',
                    fill: '#82869E',
                },
            },
        ],
    };
    const { style } = props;
    const _a = style || {}, { fontSize, color: passColor } = _a, rest = __rest(_a, ["fontSize", "color"]);
    const size = fontSize || 16;
    const color = passColor;
    return (React.createElement(Icon, Object.assign({}, props, { style: rest, ref: ref, component: () => (React.createElement(IconBase, { color: color, size: size, data: data, overrideColor: true })) })));
};
const TreeviewOutlined = React.forwardRef(IconComponent);
TreeviewOutlined.displayName = 'TreeviewOutlined';

export { TreeviewOutlined };
